// extracted by mini-css-extract-plugin
module.exports = {"link":"TextPage_link__12d1Y","textList":"TextPage_textList__1UERG"};